<template>
  <div class="success-ident-wrapper">
    <div class="container-box text-align-center flex-align-center">
      <img src="files/lidl/images/new-icons/svg/info-blue-bg.svg" alt="">
      <h2 class="text-3xl">
        <strong>Fast geschafft!</strong>
        <br />
        <strong>Die Registrierung deiner <span class="uppercase">sim</span>-Karte war erfolgreich.</strong>
      </h2>
      <p>{{ identificationDescription }}</p>
      <CustomModalWrapper ref="modalWrapper" :on-prev="closeModal" :on-next="openURL">
        <template slot="trigger">
          {{ triggerButtonText }}
          <span :class="triggerButtonIcon"></span>
        </template>
        <template slot="header">
          {{ modalHeader }}
        </template>
        <template slot="default">
          <div class="modal-body-wrapper">
            <template v-if="type === 'videoIdent'">
              <p class="text-align-left">
                Du wirst gleich weitergeleitet. Danach startet der Videoanruf, um deine <span class="uppercase">sim</span>-Karte
                zu aktivieren. Dafür brauchst du:
              </p>
            </template>
            <template v-else-if="type === 'videoIdentPost'">
              <p class="text-align-left">
                Gleich beginnt der Video-Anruf mit einem Mitarbeiter der WebID Solutions GmbH.
              </p>
              <p class="text-align-left">Dafür brauchst du:</p>
            </template>
            <template v-else>
              <p class="text-align-left">
                Hierfür benötigst du ein gültiges Ausweisdokument sowie deinen <span class="uppercase">Postident</span> Coupon. Diesen findest du zum Download
                im POSTID Portal.
              </p>
            </template>
            <div class="modal-body-list">
              <template v-if="type === 'postIdent'">
                <p>
                  <img class="icon-lg" src="/files/lidl/images/new-icons/png/profile-card-outline.png" alt="Ausweis Icon" />Gültiger
                  deutscher Personalausweis oder Reisepass
                </p>
                <p>
                  <img class="icon-lg" src="/files/lidl/images/new-icons/svg/download-outline.svg" alt="Download Icon" /><span class="uppercase">Postident</span>
                  Coupon (zum Ausdrucken oder in der <span class="uppercase">Postident</span> App)
                </p>
              </template>
              <template v-else>
                <p>
                  <img class="icon-lg" src="/files/lidl/images/new-icons/png/profile-card-outline.png" alt="Ausweis Icon" />Gültiger
                  deutscher Personalausweis oder Reisepass
                </p>
                <p>
                  <img class="icon-lg" src="/files/lidl/images/new-icons/png/computer-speaker-outline.png" alt="Kamera Icon" />Computer,
                  Tablet oder Smartphone mit einer Kamera (Mindestauflösung: 640 x 480 Pixel)
                </p>
                <p>
                  <img class="icon-lg" src="/files/lidl/images/new-icons/png/globe-outline.png" alt="Internet Icon" />Stabile
                  Internetverbindung
                </p>
                <p>
                  <img class="icon-lg" src="/files/lidl/images/new-icons/png/sun-outline.png" alt="Licht Icon" />Gute Lichtverhältnisse
                </p>
              </template>
            </div>
          </div>
        </template>
        <template slot="btnNextTxt">
          {{ nextButtonText }}
        </template>
        <template slot="btnPrevTxt">
          Abbrechen
        </template>
      </CustomModalWrapper>
      <p class="text-sm color-gray">
        {{ laterText }} <span class="custom-link" @click="showPostIdentModal = true" v-if="type === 'postIdent'"> Mehr Infos</span>
        <br />
        {{ serviceAvailabilityText }}
      </p>
    </div>
    <div class="container-box text-base">
      <h2 class="text-3xl">{{ identificationTitle }}</h2>
      <img v-if="type !== 'postIdent'" class="webid-logo" src="/files/lidl/images/new-images/webID_logo.gif" alt="WebID Logo" />
      <div class="content-limiter">
        <template v-if="type === 'postIdent'">
          <p>Voraussetzung für die Postidentifikation:</p>
          <ul class="m-0">
            <li>
              <strong>Persönlicher <span class="uppercase">Postident</span> Coupon:</strong> Deinen persönlichen Coupon kannst du dir im nächsten Schritt im <span class="uppercase">POSTID</span> Portal herunterladen. Drucke diesen aus oder nutze die <span class="uppercase">Postident</span> App zum Vorzeigen in der Postfiliale.
            </li>
            <li>
              <strong>Gültiges Ausweisdokument:</strong> Personalausweis oder Reisepass. Staatsbürger aus Syrien oder Afghanistan benötigen einen elektronischen Aufenthaltstitel (deutsch) mit Reisepass.
            </li>
          </ul>
        </template>
        <template v-else-if="type === 'videoIdentPost'">
          <p>
            Die Video-Identifikation ist eine schnelle und sichere Form der Identitätsprüfung über das Internet. In einem kurzen
            Video-Anruf gleicht ein autorisierter Mitarbeiter deine angegebenen Daten mit denen deines Ausweisdokuments ab.
          </p>
          <ul class="m-0">
            <li>
              Wenn du die Identifikation per Web-Anwendung durchführen möchten, benutzen du bitte einen Web-RTC-fähigen Browser
              <strong>(Google Chrome, Mozilla Firefox, Opera)</strong>.
            </li>
            <li>
              Wenn du die Identifikation mit deinem
              <span lang="en">Smartphone</span> oder <span lang="en">Tablet</span> durchführen möchten, dann nutze bitte die
              kostenlose<strong> <span class="uppercase">Postident</span> App</strong>.
            </li>
          </ul>
        </template>
        <template v-else>
          <p>Voraussetzungen für Video-Identifikation:</p>
          <ul class="m-0">
            <li>Gültiger deutscher Personalausweis oder Reisepass</li>
            <li>
              Computer, Tablet oder Smartphone mit einer Kamera (Mindestauflösung: 640 x 480 Pixel)
            </li>
            <li>Stabile Internetverbindung</li>
            <li>Gute Lichtverhältnisse</li>
          </ul>
          <p>
            Unser Tipp: Unter <span lang="en">iOS</span> und <span lang="en">Android</span> funktioniert der Video-Anruf am
            besten mit der WebIDent App. Kostenlos erhältlich im App Store oder im Google Play Store.
          </p>
        </template>
      </div>
    </div>
    <div class="container-box text-base">
      <div>
        <h2 class="text-3xl">Kundenkonto und Rufnummer</h2>
        <div class="py-lg content-limiter">
          <p>
            Nach Freischaltung deiner <span class="uppercase">sim</span>-Karte kannst du in deinem
            <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Kundenkonto ganz einfach und bequem deine
            Tarifoptionen verwalten oder Guthaben aufladen.
            Melde dich dazu in deinem
            <a class="link-black" title="Kundenkonto" href="http://www.lidl-connect.de/kundenkonto" target="_blank"
              >Kundenkonto</a
            >
            mit deiner <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Rufnummer und deinem Passwort an.
          </p>
          <p>
            Bitte beachte, dass <span lang="en">Promotions</span> und Gutschriften, wie zum Beispiel zusätzliches Startguthaben,
            Zusatzguthaben bei einer Aufladung oder Guthaben aus der Freundschaftswerbung in der Regel nachträglich innerhalb
            von 24 Stunden (<abbr title="maximal">max.</abbr> 3 Tage) nach Aktivierung deiner
            <span class="uppercase">sim</span>-Karte erfolgen.
          </p>
          <div class="info-box">
            <div class="flex-align-center">
              <span class="icon"></span>
              <p class="text-base-semibold">
                Deine <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Rufnummer: {{ slotData.msisdn }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomModal
      :visible="showPostIdentModal"
      title="postIdentModal"
      :showPrev="true"
      :showNext="false"
      prevText="Schließen"
      @close="closePostIdentModal"
      @prev="closePostIdentModal"
    >
      <template #header>
        POSTIDENT Coupon später downloaden
      </template>
      <template>
        <p>
          Du kannst deine Identifikation in der Postfiliale innerhalb der nächsten 14 Tage durchführen.
          Klicke zum Erhalt deines POSTIDENT Coupons einfach auf den Link in der E-Mail, die du in den nächsten Minuten von der deutschen Post erhältst.
        </p>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import CustomModalWrapper from '@/components/generic/CustomModalWrapper.vue'
import CustomModal from '@/components/generic/CustomModal.vue'
export default {
  name: 'SuccessContent',
  components: {
    CustomModalWrapper, CustomModal
  },
  props: {
    slotData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => ['videoIdent', 'videoIdentPost', 'postIdent'].includes(value)
    }
  },
  data() {
    return {
      showModal: false,
      showPostIdentModal: false
    }
  },
  methods: {
    closeModal() {
      this.$refs.modalWrapper.showModal = false
    },
    openURL() {
      window.open(this.slotData.SuccessUrl, '_blank')
    },
    closePostIdentModal() {
      this.showPostIdentModal = false
    }
  },
  computed: {
    config() {
      const typeConfig = {
        videoIdent: {
          identificationDescription:
            'Um den Aktivierungsprozess deiner SIM-Karte abzuschließen, müsst du dich nur noch per Video-Anruf identifizieren.',
          triggerButtonText: 'Jetzt identifizieren',
          triggerButtonIcon: 'icon-camera',
          modalHeader: 'Video-Identifikation starten',
          nextButtonText: 'Jetzt starten',
          laterText: 'Du möchtest die Identifikation später durchführen?',
          serviceAvailabilityText:
            'Der Service steht dir täglich von 8 bis 22 Uhr zur Verfügung. Den Link schicken wir dir automatisch als E-Mail',
          identificationTitle: 'Video-Identifikation'
        },
        videoIdentPost: {
          identificationDescription:
            'Um den Aktivierungsprozess deiner SIM-Karte abzuschließen, müsst du dich nur noch per Video-Anruf identifizieren.',
          triggerButtonText: 'VIDEO IDENTIFIKATION STARTEN & AKTIVIERUNG ABSCHLIESSEN',
          triggerButtonIcon: 'icon-camera',
          modalHeader: 'Bist du bereit?',
          nextButtonText: 'Weiter',
          laterText: 'Du möchtest die Identifikation später durchführen?',
          serviceAvailabilityText:
            'Der Service steht dir täglich von 8 bis 22 Uhr zur Verfügung. Den Link schicken wir dir automatisch als E-Mail',
          identificationTitle: 'Video-Identifikation'
        },
        postIdent: {
          identificationDescription:
            'Um den Aktivierungsprozess deiner SIM-Karte abzuschließen, musst du dich nur noch mit deinem POSTIDENT Coupon in einer Postfiliale identifizieren. ' +
            'Im POSTID Portal kannst du auch deinen POSTIDENT Coupon downloaden.',
          triggerButtonText: 'Zum POSTID Portal',
          triggerButtonIcon: 'icon-store',
          modalHeader: 'Identifikation in deiner Postfiliale',
          nextButtonText: 'Weiter',
          laterText: 'Du kannst deinen POSTIDENT Coupon auch später herunterladen.',
          serviceAvailabilityText:
            'Bitte beachte die Öffnungszeiten deiner Postfiliale.',
          identificationTitle: 'Postidentifikation'
        }
      }
      return typeConfig[this.type] || {}
    },
    identificationDescription() {
      return this.config.identificationDescription
    },
    triggerButtonText() {
      return this.config.triggerButtonText
    },
    triggerButtonIcon() {
      return this.config.triggerButtonIcon
    },
    modalHeader() {
      return this.config.modalHeader
    },
    nextButtonText() {
      return this.config.nextButtonText
    },
    laterText() {
      return this.config.laterText
    },
    serviceAvailabilityText() {
      return this.config.serviceAvailabilityText
    },
    identificationTitle() {
      return this.config.identificationTitle
    }
  }
}
</script>
